var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KPage',[_c('CondominiumHeader',[_c('KChip',{attrs:{"cyan":""}},[_vm._v(" "+_vm._s(_vm._f("quantity")(_vm.total,"abastecimentos", "abastecimento"))+" ")])],1),_c('SuppliesList',{attrs:{"condominium_id":_vm.condominium_id},on:{"load":_vm.onLoadSupplies}}),_c('v-row',{staticStyle:{"height":"38px"}}),_c('FAB',{on:{"click":_vm.add}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }